(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mega-menu featured video: close button resets the card back to its poster.
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('.mega-menu__card-close');
    if (!closeButton) return;

    // Keep the click inside the menu — don't let it toggle the <details>.
    event.preventDefault();
    event.stopPropagation();

    const media = closeButton.closest('deferred-media');
    if (!media) return;

    const player = media.querySelector('video, iframe');
    if (player) {
      if (player.tagName === 'VIDEO') player.pause();
      player.remove();
    }
    media.removeAttribute('loaded');

    // Return focus to the poster button so HeaderMenu's focusout handler
    // sees focus still inside the menu and keeps the mega menu open.
    const poster = media.querySelector('.deferred-media__poster');
    if (poster) poster.focus();
  });

  // Mobile drawer featured video: play inline on tap (filling the cards area)
  // instead of navigating. Uses an <a> (not a <button>) so the drawer's button
  // handler doesn't close it; the close button is created dynamically for the
  // same reason (the drawer only binds buttons that exist at construction).
  const drawerCloseIcon =
    '<svg aria-hidden="true" focusable="false" viewBox="0 0 18 17" fill="none">' +
    '<path d="M.865 15.978a.5.5 0 0 0 .707.707l7.417-7.417 7.418 7.417a.5.5 0 0 0 .707-.707l-7.417-7.418 7.417-7.417A.5.5 0 0 0 16.207.87L8.79 8.287 1.372.87a.5.5 0 1 0-.707.707l7.417 7.417L.865 15.978Z" fill="currentColor"/></svg>';

  document.addEventListener('click', (event) => {
    // Close button: stop the video and restore the cards.
    const closeButton = event.target.closest('.menu-drawer__mega-close');
    if (closeButton) {
      event.preventDefault();
      const playingCard = closeButton.closest('.menu-drawer__mega-card--video');
      const media = playingCard && playingCard.querySelector('video, iframe');
      if (media) {
        if (media.tagName === 'VIDEO') media.pause();
        media.remove();
      }
      closeButton.remove();
      if (playingCard) playingCard.classList.remove('is-playing');
      return;
    }

    const card = event.target.closest('.menu-drawer__mega-card--video');
    if (!card) return;

    event.preventDefault();
    if (card.classList.contains('is-playing')) return;

    const mediaWrap = card.querySelector('.menu-drawer__mega-media');
    const template = card.querySelector('.menu-drawer__mega-video-template');
    if (!mediaWrap || !template) return;

    const player = template.content.firstElementChild.cloneNode(true);
    player.setAttribute('playsinline', '');
    mediaWrap.appendChild(player);

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'menu-drawer__mega-close';
    close.setAttribute('aria-label', 'Close video');
    close.innerHTML = drawerCloseIcon;
    mediaWrap.appendChild(close);

    card.classList.add('is-playing');
    if (player.tagName === 'VIDEO') player.play();
  });

  // Mobile drawer "View all": reveal the hidden links inline (toggle).
  document.addEventListener('click', (event) => {
    const viewAll = event.target.closest('[data-view-all]');
    if (!viewAll) return;

    event.preventDefault();
    const container = viewAll.closest('.menu-drawer__mega');
    if (!container) return;

    const expanded = container.classList.toggle('is-expanded');
    viewAll.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();
})();
